<template>
  <div class="horizontal-button-group">
    <a
      v-for="item in options"
      :key="item.value"
      :id="item.value"
      @click="handleButtonClick"
      class="horizontal-button-group__item"
      >{{ item.text }}</a
    >
  </div>
</template>

<script>
export default {
  props: ["options", "handleClick"],
  methods: {
    handleButtonClick(e) {
      this.$emit("handleClick", e.target.id);
    }
  }
};
</script>

<style scoped>
.horizontal-button-group {
  display: flex;
  align-items: center;
}

.horizontal-button-group__item {
  padding: 0 15px;
  color: #2e79ef;
  cursor: pointer;
}

.horizontal-button-group__item:not(:first-child) {
  border-left: 1px solid #2e79ef;
}
</style>
